import type { AxiosInstance } from 'axios'
import type {
    IAccountData,
    IChildProtectAccepted,
    IGuardianAccount,
} from '@/typings/account'
import { NO_CONTENT_CODE } from '@/config/httpCodes.ts'

export default (axios: AxiosInstance) => ({
    getMyAccount: async (): Promise<IAccountData> => {
        const { data } = await axios.get<IAccountData>('/guardian/account/guardians/me')

        return data
    },

    getIsChildProtectAccepted: async (): Promise<IChildProtectAccepted> => {
        const { data } = await axios.get<IChildProtectAccepted>(
            '/guardian/account/guardians/child-protect-accepted',
        )

        return data
    },

    acceptChildProtect: async (): Promise<boolean> => {
        const { status } = await axios.patch('/guardian/account/guardians/child-protect/accept')

        return status === NO_CONTENT_CODE
    },

    acceptCurrentTermsForSubAccount: async (subAccountId: string): Promise<boolean> => {
        const { status } = await axios.patch(
            `/guardian/account/guardians/terms/current/${subAccountId}/accept`,
        )

        return status === NO_CONTENT_CODE
    },

    getGuardiansByIds: async (ids: string[]): Promise<IGuardianAccount[]> => {
        const { data } = await axios.post<IGuardianAccount[]>(
            '/guardian/account/guardians/by-ids',
            {
                accountIds: ids,
            },
        )

        return data
    },
})
